import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatMenuModule, MatMenu } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { DataSharingService } from '../shared/data-sharing.service';
import { CreatePersonDialogComponent } from '../create-person-dialog/create-person-dialog.component';
import { PersonInformationComponent } from '../person-information/person-information.component';
import { InputIdDialogComponent } from '../input-id-dialog/input-id-dialog.component';
import { AccountService } from '../account-service.service';
import { PersonService } from '../person.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { SubClan } from '../models/clan-interfaces'; // Import the interface
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '../app.component';
import { provideHttpClient } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    // Other providers here
  ],
}).catch((err) => console.error(err));

@Component({
  selector: 'app-clan-menu',
  standalone: true,
  imports: [
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule,
    // TODO: `HttpClientModule` should not be imported into a component directly.
    // Please refactor the code to add `provideHttpClient()` call to the provider list in the
    // application bootstrap logic and remove the `HttpClientModule` import from this component.
    //HttpClientModule
  ],
  template: `
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="setFather()">
        <span>{{ 'clan-menu.ASSIGN_FATHER' | translate }}</span>
      </button>
      <button mat-menu-item (click)="addFather()">
        <span>{{ 'clan-menu.ADD_FATHER' | translate }}</span>
      </button>
      <button mat-menu-item (click)="addSibling()">
        <span>{{ 'clan-menu.ADD_SIBLING' | translate }}</span>
      </button>
      <button mat-menu-item (click)="setMother()">
        <span>{{ 'clan-menu.ASSIGN_MOTHER' | translate }}</span>
      </button>
      <button mat-menu-item (click)="addChild()">
        <span>{{ 'clan-menu.ADD_CHILD' | translate }}</span>
      </button>
      <button mat-menu-item (click)="removePerson()">
        <span>{{ 'clan-menu.REMOVE' | translate }}</span>
      </button>
      <button mat-menu-item (click)="openInformationDialog()">
        <mat-icon>info</mat-icon>
        <span>{{ 'clan-menu.INFORMATION' | translate }}</span>
      </button>
    </mat-menu>
  `,
  providers: [
    AccountService, // Add your service here
    PersonService,
  ],
  styles: [],
})
export class ClanMenuComponent {
  @ViewChild('menu') menu!: MatMenu;
  @Output() dialogClosed = new EventEmitter<SubClan>(); // Event to emit when the dialog closes

  private http: HttpClient;

  constructor(
    private accountService_: AccountService,
    private personService: PersonService,
    http: HttpClient,
    public CreatePersonDialog: MatDialog,
    private dataSharingService: DataSharingService,
    private translate: TranslateService,
  ) {
    this.http = http;
  }

  addChild(): void {
    this.dataSharingService.setActiveUri('addChild');
    this.dataSharingService.setTargetCaption('Add Child');
    this.openDialog('0ms', '0ms');
  }

  addSibling(): void {
    this.dataSharingService.setActiveUri('addSibling');
    this.dataSharingService.setTargetCaption('Add Sibling');
    this.openDialog('0ms', '0ms');
  }

  setMother(): void {
    this.dataSharingService.setActiveUri('setMother');
    this.dataSharingService.setTargetCaption('Set Mother');
    this.openInputIdDialog('Set code Of mother', 'setMother');
  }

  setFather(): void {
    this.dataSharingService.setActiveUri('setFather');
    this.dataSharingService.setTargetCaption('Set Father');
    this.openInputIdDialog('Set code Of Father', 'setFather');
  }

  addFather(): void {
    this.dataSharingService.setActiveUri('addFather');
    this.dataSharingService.setTargetCaption('Add Father');
    this.openDialog('0ms', '0ms');
  }

  readPersonInfo(): void {
    this.dataSharingService.setActiveUri('readPerson');
    this.dataSharingService.setTargetCaption('Read person');
    this.openDialog('0ms', '0ms');
  }

  removePerson(): void {
    this.dataSharingService.setActiveUri('removePerson');
    this.dataSharingService.setTargetCaption('Remove person');
    this.personService
      .run(
        this.dataSharingService.getTargetPerson(),
        this.dataSharingService.getActiveUri(),
      )
      .subscribe({
        next: (response) => {
          console.log('Person removed successfully:', response);
          // this.onRowSelectionChange(this.dataSharingService.getLastSelectedRow());
        },
        error: (error) => {
          console.error('Error removing person:', error);
        },
      });
  }

  openInformationDialog(): void {
    this.dataSharingService.setActiveUri('readPerson');
    this.dataSharingService.setTargetCaption('read person');
    const targetPerson = this.dataSharingService.getTargetPerson();
    if (!targetPerson) {
      console.error('No target person selected');
      return;
    }
    this.personService
      .run(targetPerson, this.dataSharingService.getActiveUri())
      .subscribe({
        next: (response) => {
          console.log('Person removed successfully:', response);
          this.dataSharingService.setTargetPerson(response);
          this.CreatePersonDialog.open(PersonInformationComponent, {
            data: { person: this.dataSharingService.getTargetPerson() },
          });
        },
        error: (error) => {
          console.error('Error removing person:', error);
        },
      });
  }

  openInputIdDialog(inputLable: string, apiUrlstr: string) {
    const dialogRef = this.CreatePersonDialog.open(InputIdDialogComponent, {
      data: {
        label: inputLable,
        apiUrl: this.dataSharingService.getActiveUri(),
        currentId: this.dataSharingService.getTargetPerson().id,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Dialog closed');
    });
  }

  openDialog(
    enterAnimationDuration: string,
    exitAnimationDuration: string,
  ): void {
    // Open the dialog without passing data through the data property
    const dialogRef = this.CreatePersonDialog.open(
      CreatePersonDialogComponent,
      {
        height: '400px',
        width: '300px',
        enterAnimationDuration,
        exitAnimationDuration,
      },
    );

    dialogRef.afterClosed().subscribe((result) => {
      this.onDialogClose(result);
    });
  }

  onDialogClose(result: any): void {
    console.log('Dialog closed with result:', result);
    const lastSelectedRow = this.dataSharingService.getLastSelectedClan();
    this.dialogClosed.emit(lastSelectedRow); // Emit the lastSelectedRow
  }
}
